import { render, staticRenderFns } from "./ComparisonHelp.vue?vue&type=template&id=dd5bb32c"
import script from "./ComparisonHelp.vue?vue&type=script&lang=js"
export * from "./ComparisonHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports